export const meta = {
  title: '通知：您的顾客何时会收到什么',
  updatedAt: '2026-07-17',
  related: ['broadcasts', 'queue-board'],
};

顾客不会站在窗边盯着自己的车——应用会通知他们。本页列出确实存在的每一种通知、送达的前提条件，以及尚未建成的部分。

## 自动推送

排队板上的每一次工单流转，都会向下单的顾客推送一条通知：

- **进入队列** —— _“您已排上队。”_
- **开始清洗** —— _“正在清洗中。”_
- **完成待取** —— _“可以取车了。”_ 就是这条把顾客带回柜台。
- **已取消** —— 不让任何人苦等一张已经不存在的工单。
- **已暂停** —— 位置是暂停，不是丢了。

还有两点值得知道：当一次洗车把顾客推上更高的会员等级时，他们会当场收到一条祝贺推送。以及一条**不存在**的：工单取车付款后没有推送——没有收据通知。积分和历史都在应用里，但不会响。

## 先要满足什么

推送需要顾客授权。应用会在合适的时机开口——刚下单之后、通知明显有用的那一刻——绝不在首次打开时冷冰冰地弹窗。如果顾客拒绝，一切照常：他们仍能在应用里实时看着工单前进，只是不会被提醒。

## 顾客能控制什么

在应用的通知设置里，每位顾客可以分别选择：

- **洗车进度**与**营销**，按渠道分开设置。
- **免打扰时段** —— 一个夜间窗口（默认 22:00–08:00），期间营销保持静默。

洗车进度更新被视为必要信息，只要推送开着就一定送达。营销则严格遵守顾客意愿：每一次群发都会执行退订和免打扰时段——跳过明细如何呈报给您，见群发一文。

## 诚实的边界

- **通知文案是固定的，且目前只有英文。** 还不能按企业自定义通知文字，也还不会跟随顾客的应用语言。
- **WhatsApp 和短信今天不发送任何内容。** 顾客设置里有这些开关，平台也预留了 WhatsApp 集成的位置，但目前没有任何 WhatsApp 或短信消息发出——推送是唯一在用的渠道。等 WhatsApp 支持上线（使用您自己的企业号码），本手册会补上它的配置文章。
